<!--  -->
<template>
  <div>
    <div
      class="item-every draggable_item"
      :class="`a${every.id}`"
      :data-id="every.id"
      draggable="true"
      :style="{
        background: getBackgroundColor(every),
        border: mainSource ? 'solid 3px #FFFFFF' : 'solid 0px transparent'
      }"
      @mouseenter="onMouseenter"
      @mouseleave="onMouseleave"
      @click="editBox(every)">
      <!-- 是否有source -->
      <el-tooltip class="item" effect="dark"  placement="bottom-start" v-if="sourceBlank" >
        <div slot="content">{{IfSourceBlank}}</div>
        <span class="warning" ><i class="iconfont icon-a-eventwarning" ></i></span>
      </el-tooltip>
      <!-- 开始事件-结束事件 -->
      <div
        class="item-start"
        v-if="every.item.multipleModelType||every.item.eventModelType"
      >{{every.item.multipleModelType?'F/O':''}} {{every.item.multipleModelType&&every.item.eventModelType?'&':''}} {{mode[every.item.eventModelType]}}</div>
      <div class="item-start" v-else>{{startTime(every)+' - '+endTime(every)}}</div>
      <event-icon-wrap :event="every.item"></event-icon-wrap>
      <event-metadata v-if="EventMetadataShow" :event="every.item" :BoxPosition="BoxPosition"></event-metadata>
    </div>
     <!-- 子事件 -->
    <div v-for="(item,index) in every.eventSegments" :key="index">
      <div  class="eventSegments" v-if="item.segmentId==13" :style="{
        background: getBackgroundColor(every),
          border: `1px solid ${getBorderColor(every.backgroundColor)}`
      }">
        <!-- 子事件title -->
        <div  class="title">{{item.eventOperationType}}</div>
        <!--子事件开始-结束时间  -->
        <div class="IN">IN: {{segmentsTiming(item.timingIn)}} <span v-if="item.eventOperationType!='SCTE'"> OUT: {{segmentsTiming(item.timingOut)}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import { EventBorderColor } from '@/assets/js/common/ParamConfig.js'
import EventMetadata from '@/components/common/EventMetadata/EventMetadata.vue'
import EventIconWrap from '@/components/common/EventMetadata/EventIconWrap.vue'
export default {
  props: {
    // 日事件信息
    every: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    EventMetadata,
    EventIconWrap
  },
  data () {
    return {
      // 事件边框颜色配置
      colors: EventBorderColor,
      // SOURCE空白
      sourceBlank: 1,
      // 主源是否为空
      mainSource: false,
      // 鼠标位置
      BoxPosition: {},
      // 数据是否显示
      EventMetadataShow: false
    }
  },
  computed: {
    // 判断source是否为空
    IfSourceBlank () {
      let Point = ''
      if (this.sourceBlank == 1) {
        Point = this.$t('lang.gapPoint')
      } else if (this.sourceBlank == 2) {
        Point = this.$t('lang.sourceBlank')
      } else if (this.sourceBlank == 3) {
        Point = this.$t('lang.gapSourceBlank')
      }
      return Point
    }
  },
  watch: {
    'every.eventSegments' () {
      this.EventSourceKong()
    }
  },
  created () {
    this.EventSourceKong()
  },
  mounted () {

  },
  methods: {
    onMouseenter (e) {
      const BoxPosition = {
        top: e.clientY,
        left: e.clientX,
        bottom: document.documentElement.clientHeight - e.clientY,
        right: document.documentElement.clientWidth - e.clientX
      }
      this.BoxPosition = BoxPosition
      this.EventMetadataShow = true
    },
    onMouseleave () {
      this.EventMetadataShow = false
    },
    // 点击事件编辑弹框
    editBox (e) {
      this.$emit('editBox', e)
    },
    // 事件开始时间
    startTime (item) {
      return Outil.changeNewTime(item.startTime)
    },
    // 事件结束时间
    endTime (item) {
      return Outil.changeNewTime(item.endTime)
    },
    // 子事件开始结束时间
    segmentsTiming (item) {
      return Outil.changeNewTime(item)
    },
    // 事件背景颜色
    getBackgroundColor (item) {
      if (item.liveStatus == 0) {
        return item.backgroundColor
      }
      if (item.liveStatus == 1) {
        // 正在执行的事件为green
        return 'rgb(15, 190, 113)'
      }
      if (item.liveStatus == 2 || (item.liveStatus == 4 && (item.failedReason == 'Take Next'))) {
        return '#777777'
      }
      if ((item.liveStatus == 4 && (item.failedReason != 'Take Next')) || item.liveStatus == 5 || item.liveStatus == 6) {
        return '#8A4B4B'
      }
    },
    // 事件边框
    getBorderColor (color) {
      return this.colors[color]
    },
    // 判断事件source是否为空，是否占满事件
    EventSourceKong () {
      let TimeBlack = false
      let sourceBlank = false
      if (!this.every.item.tpeerid) {
        sourceBlank = true
        this.mainSource = true
      } else {
        this.mainSource = false
      }
      let lastEvent
      this.every.eventSegments.forEach(item => {
        // 事件scte是否是开始 判断是否是scte类型
        if (item.segmentId == 2 || item.segmentId == 4 || item.segmentId == 11) {
          // 判断scte是否在开始一分钟之内
          this.IsScteStart = this.every.startTime > (item.timingIn - 60 * 1000)
        }
        if (item.segmentId == 4 || item.segmentId == 5 || item.segmentId == 10 || ((item.segmentId == 2 || item.segmentId == 11) && item.eventOperationType != 'Scte only')) {
          if (!item.sourceId) {
            sourceBlank = true
          }
        }
        if (item.segmentId != 13) {
          lastEvent = item
        }
      })
      if (lastEvent) {
        if (lastEvent.timingOut < this.every.endTime) {
          TimeBlack = true
        }
      }
      if (TimeBlack && sourceBlank) {
        this.sourceBlank = 3
      } else if (TimeBlack) {
        this.sourceBlank = 1
      } else if (sourceBlank) {
        this.sourceBlank = 2
      } else {
        this.sourceBlank = 0
      }
    }
  }
}
</script>

<style scoped lang="less">
.item-every{
  border-radius: 5px;
  display: flex;
  position: relative;
  cursor: pointer;
  .warning{
    i{
      color: #EC5050 ;
    }
    .grayWarning{
      color: #2c3e50;
    }
    padding-left: 5px;
  }
  .item-start{
    color: #333;
    text-align: left;
    line-height: 28px;
    width: 50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 5px;
  }
}
.eventSegments{
  display: flex;
  background-color: red;
  margin-left: 20px;
  border-radius: 4px;
  .title{
  color: #252525;
    width: 30%;
    text-align: left;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .IN{
    color: #252525;
    width: 70%;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .OUT{
    color: #252525;
    width: 70%;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
